<template>
  <div>
    <!-- 图片展示 -->
    <img :src="src" :alt="alt" class="preview-image" @error="$emit('error', $event)" @click="openPreview"
      v-if="showPreview">
    <!-- 预览模态框 -->
    <div v-if="showModal" class="preview-modal" @click.self="closePreview">
      <span class="close-btn" style="font-size: 40px !important;" @click="closePreview">&times;</span>

      <!-- 上一张按钮 -->
      <div v-if="previewSrcList.length > 1" class="nav-btn prev-btn" @click="prevImage">
        <span class="arrow" style="font-size: 40px !important;">&#x2039;</span>
      </div>

      <!-- 加载提示 -->
      <div v-if="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>
      
      <img v-else-if="currentPreviewSrc" :src="currentPreviewSrc" class="modal-image">

      <!-- 下一张按钮 -->
      <div v-if="previewSrcList.length > 1" class="nav-btn next-btn" @click="nextImage">
        <span class="arrow" style="font-size: 40px !important;">&#x203A;</span>
      </div>

      <!-- 图片计数器 -->
      <div v-if="previewSrcList.length > 1" class="image-counter">
        {{ internalIndex + 1 }} / {{ previewSrcList.length }}
      </div>
    </div>
  </div>
</template>

<script>
import { getPhotoPreview } from '@/api/talkytimes/message.js'

export default {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    previewSrc: {
      type: String,
      default: ''
    },
    previewSrcList: {
      type: Array,
      default: () => []
    },
    currentIndex: {
      type: Number,
      default: 0
    },
    showPreview: {
      type: Boolean,
      default: true
    },
    listFields: {
      type: String,
      default: ''
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      showModal: false,
      currentPreviewSrc: '',
      internalIndex: this.currentIndex,
      isLoading: false
    }
  },
  methods: {
    async openPreview() {
      // 如果有id属性，调用接口获取图片预览URL
      if (this.id) {
        this.isLoading = true;
        this.showModal = true;
        document.body.style.overflow = 'hidden';
        
        try {
          const response = await getPhotoPreview({
            idPhoto: this.id,
            preview: this.src
          });
          console.log(response, 'response');
          // 根据接口返回的数据格式解析URL
          if (response && response.data) {
            this.currentPreviewSrc = response.data.url;
            this.internalIndex = 0;
          } else {
            // 如果接口调用失败，使用原图片
            this.currentPreviewSrc = this.src;
            this.internalIndex = 0;
          }
        } catch (error) {
          console.error('获取图片预览失败:', error);
          // 接口调用失败时，使用原图片
          this.currentPreviewSrc = this.src;
          this.internalIndex = 0;
        } finally {
          this.isLoading = false;
        }
        return;
      }

      // 如果有预览图片列表，使用传入的索引或查找当前图片索引
      if (this.previewSrcList.length > 0) {
        if (this.currentIndex >= 0 && this.currentIndex < this.previewSrcList.length) {
          // 使用传入的索引
          this.internalIndex = this.currentIndex;
        } else {
          // 查找当前图片在列表中的索引
          const targetSrc = this.previewSrc || this.src;
          this.internalIndex = this.previewSrcList.findIndex(item => item === targetSrc);
          if (this.internalIndex === -1) {
            this.internalIndex = 0;
          }
        }
        let listFields = this.listFields;
        if (listFields) {
          this.currentPreviewSrc = this.previewSrcList[this.internalIndex][listFields];
        } else {
          this.currentPreviewSrc = this.previewSrcList[this.internalIndex];
        }
      } else {
        // 如果没有预览图片列表，使用指定的预览图片或原图片
        this.currentPreviewSrc = this.previewSrc || this.src;
        this.internalIndex = 0;
      }

      this.showModal = true;
      document.body.style.overflow = 'hidden';
    },
    closePreview() {
      this.showModal = false;
      document.body.style.overflow = '';
    },
    async prevImage() {
      if (this.previewSrcList.length > 0) {
        this.internalIndex = (this.internalIndex - 1 + this.previewSrcList.length) % this.previewSrcList.length;
        
        // 如果有id属性，调用接口获取高清图片
        if (this.id) {
          this.isLoading = true;
          let currentSrc = this.listFields 
            ? this.previewSrcList[this.internalIndex][this.listFields] 
            : this.previewSrcList[this.internalIndex];
            
          try {
            const response = await getPhotoPreview({
              idPhoto: this.id,
              preview: currentSrc
            });
            if (response && response.data) {
              this.currentPreviewSrc = response.data.url;
            } else {
              this.currentPreviewSrc = currentSrc;
            }
          } catch (error) {
            console.error('获取图片预览失败:', error);
            this.currentPreviewSrc = currentSrc;
          } finally {
            this.isLoading = false;
          }
        } else {
          // 没有id时使用原逻辑
          let listFields = this.listFields;
          if (listFields) {
            this.currentPreviewSrc = this.previewSrcList[this.internalIndex][listFields];
          } else {
            this.currentPreviewSrc = this.previewSrcList[this.internalIndex];
          }
        }
      }
    },
    async nextImage() {
      if (this.previewSrcList.length > 0) {
        this.internalIndex = (this.internalIndex + 1) % this.previewSrcList.length;
        
        // 如果有id属性，调用接口获取高清图片
        if (this.id) {
          this.isLoading = true;
          let currentSrc = this.listFields 
            ? this.previewSrcList[this.internalIndex][this.listFields] 
            : this.previewSrcList[this.internalIndex];
            
          try {
            const response = await getPhotoPreview({
              idPhoto: this.id,
              preview: currentSrc
            });
            if (response && response.data) {
              this.currentPreviewSrc = response.data.url;
            } else {
              this.currentPreviewSrc = currentSrc;
            }
          } catch (error) {
            console.error('获取图片预览失败:', error);
            this.currentPreviewSrc = currentSrc;
          } finally {
            this.isLoading = false;
          }
        } else {
          // 没有id时使用原逻辑
          let listFields = this.listFields;
          if (listFields) {
            this.currentPreviewSrc = this.previewSrcList[this.internalIndex][listFields];
          } else {
            this.currentPreviewSrc = this.previewSrcList[this.internalIndex];
          }
        }
      }
    },
    handleKeydown(e) {
      if (this.showModal) {
        switch (e.key) {
          case 'Escape':
            this.closePreview();
            break;
          case 'ArrowLeft':
            this.prevImage();
            break;
          case 'ArrowRight':
            this.nextImage();
            break;
        }
      }
    }
  },
  mounted() {
    // 添加键盘导航支持
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
</script>

<style scoped>
.preview-image {
  cursor: pointer;
  transition: all 0.3s;
  max-width: 100%;
}

.preview-image:hover {
  opacity: 0.8;
}

.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 30px;
  color: #fff;
  font-size: 40px !important;
  font-weight: bold;
  cursor: pointer;
  z-index: 10000;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #ccc;
}

.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 40px !important;
  font-weight: bold;
  cursor: pointer;
  z-index: 10000;
  user-select: none;
  border-radius: 50%;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.nav-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.6);
  transform: translateY(-50%) scale(1.1);
}

.nav-btn:active {
  transform: translateY(-50%) scale(0.95);
}

.prev-btn {
  left: 30px;
}

.next-btn {
  right: 30px;
}

.image-counter {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 16px !important;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 8px 16px;
  border-radius: 20px;
  z-index: 10000;
}

.arrow {
  display: inline-block;
  line-height: 1;
  transform: translateY(-6px) translateX(-2px);
}

.next-btn .arrow {
  transform: translateY(-6px) translateX(2px);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #fff;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

.loading-text {
  font-size: 16px;
  color: #fff;
  text-align: center;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>